import mutationObserver from '~/plugins/mutationObserver';
import CommonMixin from '@/mixins/templates/common.js';

const observer = mutationObserver();

export default {
  mixins: [CommonMixin],
  data() {
    return {
      editorKey                    : 0,
      accessibilityTheme           : 'default',
      isDarkContrastMode           : false,
      isEqualWebMenuOpen           : false,
      hasEqualwebTextReaderEnabled : false

    };
  },
  mounted() {
    const body = document.getElementsByTagName('body')[0];
    const config = { attributes: true };

    this.getAccessibilityTheme(body.classList);

    const callback = (mutationsList, observer) => {
      const mutation = mutationsList[mutationsList.length - 1];
      if (mutation && mutation.type === 'attributes') {
        this.getAccessibilityTheme(mutation.target.classList);
        this.isEqualWebMenuOpen = mutation.target.classList.contains('INDmenu-open');
        this.isDarkContrastMode = this.accessibilityTheme === 'blackContrast' || this.currentTheme === 'theme--plataforma-black';
      }
    };
    observer.observe(body, config, callback);

    this.isDarkContrastMode = this.currentTheme === 'theme--plataforma-black';
  },
  destroyed() {
    observer.disconnect();
  },
  watch: {
    accessibilityTheme(newValue, oldValue) {
      if (newValue === 'blackContrast') {
        this.isDarkContrastMode = true;
      } else if (oldValue === 'blackContrast') {
        this.isDarkContrastMode = false;
      };
    },
    isDarkContrastMode(newValue) {
      if (newValue) {
        this.$emit('incrementEditorKey');
        this.editorKey++;
      }
    }
  },
  methods: {
    getAccessibilityTheme(classList) {
      if (classList.contains('INDmonochrome')) {
        this.accessibilityTheme = 'monochromeContrast';
      } else if (classList.contains('INDblackwhite')) {
        this.accessibilityTheme = 'blackContrast';
      } else if (classList.contains('INDwhiteblack')) {
        this.accessibilityTheme = 'whiteContrast';
      } else {
        this.accessibilityTheme = 'default';
      }
    },
    setupEqualwebTextReaderObserver() {
      const EQUALWEB_TEXTREADER_CLASS = 'INDTextReader';
      this.hasEqualwebTextReaderEnabled = Array.from(document?.body?.classList).includes(EQUALWEB_TEXTREADER_CLASS);

      const observerConfig = {
        attributes      : true,
        attributeFilter : ['class']
      };

      observer.observe(document.body, observerConfig, mutations => {
        for (const mutation of mutations) {
          const changedAttribute = mutation.target.getAttribute(mutation.attributeName);

          this.hasEqualwebTextReaderEnabled = changedAttribute?.includes(EQUALWEB_TEXTREADER_CLASS);
        }
      });
    }
  }
};
